import React, { useEffect, useState } from 'react'
import dayjs from 'dayjs';
import ToastMessage from '../../../common/ToastMessage';
import CustomDataGrid from '../../../common/CustomDataGrid';
import useIncident from '../../../store/ReactQueries/incidents/useIncident';
import useDeleteIncident from '../../../store/ReactQueries/incidents/useDeleteIncident';
import { GridColDef } from '@mui/x-data-grid';
import { PAGESIZE } from '../../../utils/constants';
import { StorageItems } from '../../../utils/storageItems';
import { IncidentInterface } from '../../../models/Incident';
import { FieldErrors } from '../../../domain/helpers/Errors';
import { useLanguageStore } from '../../../store/useLanguageStore';

export const Incidents = () => {
    const storedPage = localStorage.getItem(StorageItems.IncidentPage);
    const storedPageSize = localStorage.getItem(StorageItems.IncidentPageSize);

    const { language } = useLanguageStore();

    const [page, setPage] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(PAGESIZE);
    const [errors, setErrors] = useState<FieldErrors>({});
    const [form, setForm] = useState<IncidentInterface>({
        id: '',
        title: '',
        stepsTaken: '',
        dateTime: undefined,
    });

    let { data: incidents, isLoading, error } = useIncident(page, pageSize);

    const deleteIncident = useDeleteIncident(page, pageSize);

    const columns: GridColDef[] = [
        { field: 'id', headerName: 'Id', type: "string", editable: false },
        { field: 'title', headerName: 'Incident', type: "string", editable: false, width: 200 },
        { field: 'stepsTaken', headerName: 'Steps Taken', type: "string", editable: false, width: 500 },
        {
            field: 'dateTime',
            headerName: 'Time',
            type: "string",
            editable: false,
            renderCell: ({ row }) => <span>{row.dateTime ? `${dayjs(row.dateTime).format('HH:mm')}h` : undefined}</span>,
        },
        {
            field: 'createdDate',
            headerName: 'CreatedDate',
            type: "string",
            width: 200,
            editable: false,
            renderCell: ({ row }) => <span>{row.createdDate ? dayjs(row.createdDate).format('DD MMMM YYYY HH:mm') : ''}</span>,
        },
        {
            field: 'updatedDate',
            headerName: 'UpdatedDate',
            type: "string",
            editable: false,
            width: 200,
            renderCell: ({ row }) => <span>{row.updatedDate ? dayjs(row.updatedDate).format('DD MMMM YYYY HH:mm') : ''}</span>,
        },
    ];

    localStorage.setItem(StorageItems.IncidentPage, page.toString());
    localStorage.setItem(StorageItems.IncidentPageSize, pageSize.toString());

    useEffect(() => {
        setTimeout(() => {
            const previousLocation = localStorage.getItem('PreviousLocation');
            const isNotTicketPath = !['/incidents/', '/incident/'].some(path => previousLocation?.includes(path));
            if (previousLocation === '') {
                setPage(storedPage ? parseInt(storedPage) : 1);
                setPageSize(storedPageSize ? parseInt(storedPageSize) : 20);
            }
            else if (isNotTicketPath) {
                setPage(1);
                setPageSize(PAGESIZE);
            } else {
                setPage(storedPage ? parseInt(storedPage) : 1);
                setPageSize(storedPageSize ? parseInt(storedPageSize) : 20);
            }
        }, 100);
    }, []);

    useEffect(() => {
        if (error) ToastMessage.Failed(`Error: ${error.message}`);
    }, [error]);

    const handleDelete = async (id: string) => {
        if (await ToastMessage.Confirm(language['ToastDeleteItem'])) {
            deleteIncident.mutate(id, {
                onSuccess: () => ToastMessage.Success(),
                onError: (error) => {
                    if (error instanceof Error) ToastMessage.Failed(error.message);
                    else ToastMessage.Failed();
                }
            });
        }
    };

    return (
        <CustomDataGrid
            name={language['Incidents']}
            rows={incidents || []}
            form={form}
            page={page}
            errors={errors}
            columns={columns}
            pageSize={pageSize}
            loading={isLoading}
            addItems={() => { }}
            handleSave={function (): Promise<void> {
                throw new Error('Function not implemented.');
            }}
            modal={{
                add: false,
                edit: false,
                view: false
            }}
            setModal={function (value: React.SetStateAction<{ add: boolean; edit: boolean; view: boolean; }>): void {
                throw new Error('Function not implemented.');
            }}
            setForm={setForm}
            setPage={setPage}
            setErrors={setErrors}
            setPageSize={setPageSize}
            handleDelete={handleDelete}
            hideColumns={['id']}
            showColumnModal={[]}
            newAddComponent='Incidents'
        />
    );
}
export default Incidents;